<div class="input-frame">
    <label :for="id" :data-text="label" class="label">
        <span>{{label}}</span>
    </label>
    <togglebox :items="items" :id="id" :disabled="disabled" :readonly="readonly" :value="_value" @input="handleInput"/>
</div>
